// extracted by mini-css-extract-plugin
export default {"burguerMenu":"HamburguerBtn_burguerMenu__WntWv","burguer":"HamburguerBtn_burguer__6416t","clicked":"HamburguerBtn_clicked__VCxSN"};